/**
 * @constructor
 * @returns {ServerCfg}
 */
export function ServerCfg() {
	/** @type {*} */
	this._serverConfig;
};

ServerCfg.prototype.lastRoundEnded = function() {
    return this._serverConfig["last_round"]["ended"];
};

/**
 * @param {Object} res
 * @returns {undefined}
 */
ServerCfg.prototype.setServerConfig = function(res) {
    this._serverConfig = JSON.parse(JSON.stringify(res));
};

/**
 * @returns {Array}
 */
ServerCfg.prototype.getPositions = function() {
    return this._serverConfig["matrix"]["position"];
};

ServerCfg.prototype.getSymbols = function() {
    return this._serverConfig["logic"]["symbols"];
};

ServerCfg.prototype.getBetSet = function() {
    return this._serverConfig["logic"]["bet_set"];
};

/**
 * @param {number=} count
 * @returns {Array}
 */
ServerCfg.prototype.getReels = function(count) {
    return this._serverConfig["logic"]["reels"];
};

ServerCfg.prototype.getReelMatrix = function() {
    return this._serverConfig["matrix"]["reelMatrix"];
};

ServerCfg.prototype.setReelMatrix = function(reelMatrix) {
    return this._serverConfig["matrix"]["reelMatrix"] = reelMatrix;
};


ServerCfg.prototype.getFailResult = function() {
    return this._serverConfig["logic"]["failResult"];
};

ServerCfg.prototype.getSpinDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["duration"];
};

/**
 * @public
 * @returns {number}
 */
ServerCfg.prototype.getSpinCommonSpeed = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["commonSpeed"];
};

/**
 * @public
 * @returns {number}
 */
ServerCfg.prototype.getSpinScatterSpeed = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterSpeed"] * 1;
};

ServerCfg.prototype.getAccHeight = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["accelerationHeight"];
};

ServerCfg.prototype.getAccMoveBackTime = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["moveBackTime"];
};

ServerCfg.prototype.getAccMoveTime = function() {
    return this._serverConfig["behavior"]["reel"]["acceleration"]["moveTime"];
};

ServerCfg.prototype.getBrakeHeight = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["brakeHeight"];
};

ServerCfg.prototype.getBrakeMoveBackTime = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["moveBackTime"];
};

ServerCfg.prototype.getBrakeMoveTime = function() {
    return this._serverConfig["behavior"]["reel"]["brake"]["moveTime"];
};

ServerCfg.prototype.getMinBigWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minBigWinFactor"];
};

ServerCfg.prototype.getMinMegaWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minMegaWinFactor"];
};

ServerCfg.prototype.getMinSuperMegaWinFactor = function() {
    return this._serverConfig["behavior"]["reel"]["minSuperMegaWinFactor"];
};

ServerCfg.prototype.getReelSpinDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["duration"];
};

/**
 * @public
 * @returns {number}
 */
ServerCfg.prototype.getDelayBetweenReelStops = function() {

    if(typeof this._serverConfig["behavior"]["reel"]["spin"]["delayBetweenReelStops"] === 'undefined') {
        return 0;
    }

    return this._serverConfig["behavior"]["reel"]["spin"]["delayBetweenReelStops"] * 1;
};

/**
 * @returns {number}
 */
ServerCfg.prototype.getScatterDelay = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterDelay"] * 1;
};

/**
 * @returns {number}
 */
ServerCfg.prototype.getScatterDuration = function() {
    return this._serverConfig["behavior"]["reel"]["spin"]["scatterDuration"] * 1;
};

ServerCfg.prototype.getVolumeBigWin = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["bigWin"];
};

ServerCfg.prototype.getVolumeButtonEffect = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["buttonEffect"];
};

ServerCfg.prototype.getVolumeSpin = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["spin"];
};

ServerCfg.prototype.getVolumeStartReel = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["startReel"];
};

ServerCfg.prototype.getVolumeStopReel = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["stopReel"];
};

ServerCfg.prototype.getVolumeWinAnim = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["winAnim"];
};

ServerCfg.prototype.getVolumeWinCounter = function() {
    return this._serverConfig["behavior"]["sound"]["volume"]["winCounter"];
};

ServerCfg.prototype.getVolumeBackground = function() {
    return this._serverConfig["behavior"]["sound"]["background"]["background"];
};

ServerCfg.prototype.getVolumeFSBackground = function() {
    return this._serverConfig["behavior"]["sound"]["background"]["freeSpinsBackground"];
};

ServerCfg.prototype.getVolumeBonusBackground = function() {
    return this._serverConfig["behavior"]["sound"]["background"]["bonusGameBackground"];
};

ServerCfg.prototype.getVolumeMiscSound1 = function() {
    return this._serverConfig["behavior"]["sound"]["miscSounds"]["miscSounds1"];
};

ServerCfg.prototype.getVolumeMiscSound2 = function() {
    return this._serverConfig["behavior"]["sound"]["miscSounds"]["miscSounds2"];
};

ServerCfg.prototype.getVolumeMiscSound3 = function() {
    return this._serverConfig["behavior"]["sound"]["miscSounds"]["miscSounds3"];
};

ServerCfg.prototype.getVolumeMiscSound4 = function() {
    return this._serverConfig["behavior"]["sound"]["miscSounds"]["miscSounds4"];
};

ServerCfg.prototype.getVolumeMiscSound5 = function() {
    return this._serverConfig["behavior"]["sound"]["miscSounds"]["miscSounds5"];
};